<template lang="pug">
  .color-wonder-pdp-product-info
    meta(itemprop="gtin12" :content="product.upc")
    h1.f-primary.upper.bold.xs-f-xsmall.max-at-tweak.cw-color-11(data-mr-ass="selected-color-name" itemprop="brand" itemscope itemtype="http://schema.org/Brand")
      span(itemprop="name") {{ productType }}
    h2.product-name.f-primary.bold.xs-f-xlarge.md-f-xxlarge.max-at-tweak.cw-color-11(data-mr-ass="selected-color-description" itemprop="name") {{ productName }}
    div(itemprop="aggregateRating" itemscope itemtype="http://schema.org/AggregateRating" :class="productReviewable ? 'product-reviewable' : 'review-wrap-outer'")
      meta(itemprop="ratingValue" :content="summary.average")
      meta(itemprop="reviewCount" :content="summary.count")
      .stars-wrap.btn-reset.xs-f-xxsmall.md-f-medium.max-at-tweak(role="button" @click="scrollToReviews" @keyup.enter="scrollToReviews" tabindex="0")
        stars.inline-block(:rating="summary.average")
        span.text-color-4 &nbsp;{{ summary.average }}&nbsp;
      span.cta-color-1.xs-f-large(:class="productReviewable ? '' : 'ml-5 mr-5'") &#x2022;
      span.text-color-4.underline.mr-stars-review-count.clickable(role="button" @click="scrollToReviews" tabindex="0") {{ summary.count }} Reviews
      span.cta-color-1.xs-f-large.xs-hide(v-if="productReviewable") &#x2022;
      mr-btn.mrbtn(xxsmall round v-if="productReviewable" @click.prevent="openReviewModal(product)") 
        span.capitalize Write a Review

</template>

<script>

  import { mapState, mapActions } from "vuex";
  import MrBtn from "@components/MrBtn";

  export default {
    name: "ColorWonderPdpProductInfo",
    
    components: {
      MrBtn
    },

    computed: {
      ...mapState('pdp', [
        'product'
      ]),

      ...mapState('reviews', ['summary']),
      ...mapState('systemSettings', ['anonymousReviewSettings']),

      productName() {
        //- color_kit is a special flake
        return this.product.product_type == 'color_kit' ? this.product.short_description : this.product.name;
      },

      productType() {
        return this.product.product_type == 'color_kit' ? this.product.name : this.product.product_type_display_name;
      },

      productReviewable() {
        return this.anonymousReviewSettings?.enabled;
      }
    },

    methods: {
      ...mapActions('modal', ['hideModal', 'showModal']),

      scrollToReviews() {
        this.$root.scrollTo('.review-wrap');
      },

      openReviewModal() {
        this.trackMREvent('PDP - Review Modal Opened');
        this.showModal({
          component: 'EditReviewModal',
          props: {
            product: this.product
          },
          theme: 'app-modal-overflow-visible',
        });
      }
    }
  };
</script>

<style lang="stylus">
.color-wonder-pdp-product-info
  padding-top 0.5em
  padding-bottom 0.75em
  text-align left

  .product-name
    letter-spacing -1px

  .review-wrap-outer
    display flex
    justify-content left
    padding 0.5em 0
    align-items center
    line-height 14px

  .product-reviewable
    display flex
    justify-content space-between
    padding 0.5em 0
    align-items center
    line-height 14px
    flex-wrap wrap

    .mrbtn
      padding 0 0.5em
      background-color cta-color-4
      font-weight 700
      line-height 14px
      letter-spacing -0.24px

      span
        padding 6px 0.5em
  
  .stars-wrap
    margin-top 0.5rem
    cursor pointer
    display flex
    align-items center
    margin-bottom 0.5rem

    .reviews
      display flex
      align-items center
      margin-top 0.1rem

      .cw-heart
        font-size 0.5rem

    .cw-stars
      > span
        color cw-color-11 !important

        &::before
          margin-right 0.1rem

  @media mq-tablet-less
    padding-left 1em
    padding-right 1em

    .product-reviewable
      justify-content space-around
      padding 0.5em 3.5em

  @media mq-desktop-md-plus
    &.version-b
      text-align left

      :deep(.mr-stars)
        span
          color brand-color-2

</style>
